import { createContext, useContext } from "react";
import { api } from "@/lib/api";

/**
 * Provides the axios client that tenant-scoped pages should use. Defaults to
 * the global ``api`` (normal /app + /admin HQ behavior). The Agency Workspace
 * overrides it with a client that injects ``X-Act-As-Tenant`` so the SAME
 * components (Pipeline, cards, appointment modal) operate on the selected
 * salon's real data without touching the global interceptor.
 */
const ApiCtx = createContext(null);

export function ApiProvider({ client, children }) {
  return <ApiCtx.Provider value={client}>{children}</ApiCtx.Provider>;
}

export function useApiClient() {
  return useContext(ApiCtx) || api;
}
